const PATH = 'fe.pages.organization.view_member';

const messages = {
  goBack: {
    key: `${PATH}.go_back`,
    defaultValue: 'Go Back'
  },
  lastLogin: {
    key: `${PATH}.last_login`,
    defaultValue: 'Last Login'
  },
  basicInformation: {
    key: `${PATH}.basic_information`,
    defaultValue: 'Basic Information'
  },
  name: {
    key: `${PATH}.name`,
    defaultValue: 'Name'
  },
  email: {
    key: `${PATH}.email`,
    defaultValue: 'Email'
  },
  externalId: {
    key: `${PATH}.external_id`,
    defaultValue: 'External ID'
  },
  role: {
    key: `${PATH}.role`,
    defaultValue: 'Role'
  },
  rolePlaceholder: {
    key: `${PATH}.role_placeholder`,
    defaultValue: 'Select role'
  },
  addedOn: {
    key: `${PATH}.added_on`,
    defaultValue: 'Added On'
  },
  addedBy: {
    key: `${PATH}.added_by`,
    defaultValue: 'Added By'
  },
  hierarchy: {
    key: `${PATH}.hierarchy`,
    defaultValue: 'Hierarchy Association'
  },
  hierarchyPlaceholder: {
    key: `${PATH}.hierarchy_placeholder`,
    defaultValue: 'Select hierarchy association for this member'
  },
  hierarchyValidationError: {
    key: `${PATH}.hierarchy_validation_error`,
    defaultValue:
      'At least one hierarchy association must be selected for the Administrator role.'
  },
  unknown: {
    key: `${PATH}.unknown`,
    defaultValue: 'Unknown'
  },
  activity: {
    key: `${PATH}.activity`,
    defaultValue: 'Activity'
  },
  noActivity: {
    key: `${PATH}.no_activity`,
    defaultValue: 'No activity found'
  },
  memberAdded: {
    key: `${PATH}.member_added`,
    defaultValue: 'added'
  },
  memberUpdated: {
    key: `${PATH}.member_updated`,
    defaultValue: 'updated the'
  },
  memberArchived: {
    key: `${PATH}.member_archived`,
    defaultValue: 'archived'
  },
  memberUnarchived: {
    key: `${PATH}.member_unarchived`,
    defaultValue: 're-activated'
  },
  none: {
    key: `${PATH}.none`,
    defaultValue: 'None'
  },
  accessRequired: {
    key: `${PATH}.access_required`,
    defaultValue: "Can't view this member"
  },
  accessRequiredDescription: {
    key: `${PATH}.access_required_description`,
    defaultValue:
      "This member isn't in your hierarchy. Add them to your hierarchy to view their profile."
  },
  addMember: {
    key: `${PATH}.add_member`,
    defaultValue: 'Add Member'
  },
  adminAccountRoleInfo: {
    key: `${PATH}.admin_account_role_info`,
    defaultValue:
      'Role can only be updated for members who have no associations outside of your hierarchy.'
  }
};

export default messages;
